import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser, { Buttons, Images } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';

export default class PopupDialog extends Phaser.GameObjects.Container {
  constructor(scene, background) {
    super(scene);

    this.dark = this.scene.add.rectangle(0,0, this.scene.scale.width, this.scene.scale.height,0x000000, 0.6).setOrigin(0)
      .setInteractive();
    this.once(Phaser.GameObjects.Events.DESTROY, (obj, fromScene) => { if (!fromScene) this.dark.destroy();});

    this.background = Images.addImage(0, 0, background, this);

    if (background === 'HomeBtnPopup') {
      this.noButton = Buttons.addButton(100 - (this.background.width / 2), (this.background.height / 2) - 28, 'NoBtn', 'NoBtn', null, null, this).setOrigin(0, 1);
      this.yesButton = Buttons.addButton((this.background.width / 2) - 100, (this.background.height / 2) - 28, 'YesBtn', 'YesBtn', null, null, this).setOrigin(1, 1);
    }
    else if (background === 'InstructionsPopup') {
      this.okButton = Buttons.addButton(0, this.background.height / 2, 'OkBtn', 'OkBtn', null, null, this);
      if (ABCyaLib.Environment.instance.gameConfig.levels !== null) {
        this.background.setFrame(UIAssetKeys._variants_Popup);

        // add the text
        this.text = ABCyaPhaser.Text.addText(0,0,40, 0xd82e00, FontKeys._carton_sixregular, `Click on one of the words at the bottom, and then find the picture of that word in the illustration.\n\nComplete ${ABCyaLib.Environment.instance.gameConfig.levels.length} stages to win!`, this, true).setOrigin(0.5)
          .setWordWrapWidth(this.background.width - 40);

        this.okButton.y += 45;
      }
    }
  };
}